"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCHOOLYEAR_END = exports.SCHOOLYEAR_START = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
// 22 august 2022
exports.SCHOOLYEAR_START = dayjs_1.default().set('year', 2022).set('month', 7).date(22).toDate();
// 7 juli 2023
exports.SCHOOLYEAR_END = dayjs_1.default().set('year', 2023).set('month', 6).date(7).toDate();
